<template>
    <v-dialog v-model="dialog" :max-width="options.width" :style="{ zIndex: options.zIndex }" @keydown.esc="cancel" v-bind:persistent="true">
        <v-snackbar v-model="dialog" app centered shaped timeout=-1>
            {{message}}&nbsp;
            <template>                                        
                <v-btn class="white--text mx-2" color="#49a5ac" v-if="options.confirm" light elevation="20" @click.native="agree"><v-icon dense left>mdi-check</v-icon>{{$t("yes")}}</v-btn>
                <v-btn class="white--text" color="#49a5ac" v-if="options.confirm" light elevation="20" @click.native="cancel"><v-icon dense left>mdi-close</v-icon>{{$t("no")}}</v-btn>
                <v-btn class="white--text mx-2" color="#49a5ac" v-if="!options.confirm" fab light elevation="20"  @click.native="agree"><v-icon dense>mdi-check</v-icon></v-btn>                
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        dialog: false,
        resolve: null,
        reject: null,
        message: null,        
        title: null,
        options:
        {
            width: 290,
            zIndex: 200,
            confirm: true
        }
    }),
    methods: {
        open(message, options)
        {
            this.dialog = true               
            this.message = message            
            this.options = Object.assign(this.options, options)
            return new Promise((resolve, reject) => {
                this.resolve = resolve
                this.reject = reject
            })
        },
        agree()
        {
            this.resolve(true)
            this.dialog = false
        },
        cancel()
        {
            this.resolve(!this.options.confirm)
            this.dialog = false
        }
    }
};
</script>